import PropTypes from "prop-types";
import { Redirect, Route } from "react-router-dom";

const PrivateRoute = ({ token, path, children, parentPath }) => {
  if (token) {
    return <Route path={path}>{children}</Route>;
  } else {
    return <Redirect to={parentPath} />;
  }
};

PrivateRoute.propTypes = {
  token: PropTypes.bool,
  path: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  parentPath: PropTypes.string.isRequired
};

export default PrivateRoute;
